// src/pages/admin/AdminLogin.js
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { WEDDING_CONFIG } from '../../config';

const AdminLogin = () => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    email: '',
    password: ''
  });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
    setError('');
  };

const handleSubmit = async (e) => {
  e.preventDefault();
  setLoading(true);
  setError('');

  try {
    // Import service
    const { adminLogin } = await import('../../services/authService');
    
    const result = await adminLogin(formData.email, formData.password);

    if (result.success) {
      // Store token in localStorage
      localStorage.setItem('adminToken', result.token);
      localStorage.setItem('adminEmail', result.admin.email);
      
      // Redirect to dashboard
      navigate('/admin/dashboard');
    }
  } catch (error) {
    console.error('Login error:', error);
    setError(error.message || 'Invalid credentials. Please try again.');
  } finally {
    setLoading(false);
  }
};

  return (
    <div style={styles.container}>
      <div style={styles.loginBox}>
        <div style={styles.header}>
          <h1 style={styles.title}>Admin Login</h1>
          <p style={styles.subtitle}>Wedding Website Dashboard</p>
        </div>

        <form onSubmit={handleSubmit} style={styles.form}>
          {error && (
            <div style={styles.errorBox}>
              <span>⚠️</span> {error}
            </div>
          )}

          <div style={styles.formGroup}>
            <label style={styles.label}>Email Address</label>
            <input
              type="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              required
              style={styles.input}
              placeholder="admin@yourwedding.com"
            />
          </div>

          <div style={styles.formGroup}>
            <label style={styles.label}>Password</label>
            <input
              type="password"
              name="password"
              value={formData.password}
              onChange={handleChange}
              required
              style={styles.input}
              placeholder="Enter your password"
            />
          </div>

          <button 
            type="submit" 
            disabled={loading}
            style={{
              ...styles.button,
              opacity: loading ? 0.6 : 1,
              cursor: loading ? 'not-allowed' : 'pointer'
            }}
          >
            {loading ? 'Logging in...' : 'Login'}
          </button>
        </form>

        <div style={styles.footer}>
          <a href="/" style={styles.backLink}>← Back to Website</a>
        </div>
      </div>
    </div>
  );
};

const styles = {
  container: {
    minHeight: '100vh',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    background: `linear-gradient(135deg, ${WEDDING_CONFIG.colors.primary}, ${WEDDING_CONFIG.colors.secondary})`,
    padding: '2rem',
  },
  loginBox: {
    background: 'white',
    borderRadius: '20px',
    padding: '3rem',
    width: '100%',
    maxWidth: '450px',
    boxShadow: '0 20px 60px rgba(0, 0, 0, 0.3)',
  },
  header: {
    textAlign: 'center',
    marginBottom: '2rem',
  },
  title: {
    fontSize: '2rem',
    color: WEDDING_CONFIG.colors.primary,
    marginBottom: '0.5rem',
  },
  subtitle: {
    fontSize: '1rem',
    color: '#666',
  },
  form: {
    display: 'flex',
    flexDirection: 'column',
    gap: '1.5rem',
  },
  formGroup: {
    display: 'flex',
    flexDirection: 'column',
    gap: '0.5rem',
  },
  label: {
    fontSize: '0.9rem',
    fontWeight: '600',
    color: '#333',
  },
  input: {
    padding: '0.8rem',
    fontSize: '1rem',
    border: `2px solid ${WEDDING_CONFIG.colors.light}`,
    borderRadius: '10px',
    outline: 'none',
    transition: 'border-color 0.3s',
  },
  button: {
    padding: '1rem',
    fontSize: '1.1rem',
    fontWeight: '600',
    color: 'white',
    background: `linear-gradient(135deg, ${WEDDING_CONFIG.colors.primary}, ${WEDDING_CONFIG.colors.secondary})`,
    border: 'none',
    borderRadius: '10px',
    cursor: 'pointer',
    transition: 'transform 0.3s',
    marginTop: '1rem',
  },
  errorBox: {
    padding: '1rem',
    background: '#fee',
    border: '2px solid #fcc',
    borderRadius: '10px',
    color: '#c33',
    fontSize: '0.9rem',
  },
  footer: {
    textAlign: 'center',
    marginTop: '2rem',
  },
  backLink: {
    color: WEDDING_CONFIG.colors.primary,
    textDecoration: 'none',
    fontSize: '0.9rem',
  }
};

export default AdminLogin;